export const CRITEO_NEWORK_ID = 6807;
export const GPT_NETWORK_ID = 21814681;
